export const PARTS = {
    "217-4973": {
        maxTorque: 157,
        cost: 39.99,
        name: "Base Kit: 1/2 Hex Output"
    },
    "217-4975": {
        maxTorque: 130,
        cost: 39.99,
        name: "Base Kit: 1/2 Round Output"
    },
    "217-4974": {
        maxTorque: 57,
        cost: 39.99,
        name: "Base Kit: 3/8 Hex Output"
    },
    "217-4976": {
        maxTorque: 27,
        cost: 39.99,
        name: "Base Kit: CIM Output"
    },
    "217-6473": {
        maxTorque: 27,
        cost: 44.99,
        name: "Base Kit: Universal Female Output"
    },
    "217-2816": {
        cost: 9.99,
        name: "Ring Gear",
    },
    "217-2817": {
        cost: 14.99,
        name: "3:1 Gear Set",
    },
    "217-2818": {
        cost: 14.99,
        name: "4:1 Gear Set",
    },
    "217-2819": {
        cost: 14.99,
        name: "5:1 Gear Set",
    },
    "217-3102": {
        cost: 14.99,
        name: "7:1 Gear Set",
    },
    "217-3106": {
        cost: 14.99,
        name: "9:1 Gear Set",
    },
    "217-2820": {
        cost: 14.99,
        name: "10:1 Gear Set",
    },
    "217-4347": {
        cost: 19.99,
        name: "775 Pro",
    },
    "217-3351": {
        cost: 29.99,
        name: "Bag Motor",
    },
    "217-3371": {
        cost: 29.99,
        name: "Mini CIM Motor",
    },
    "217-2000": {
        cost: 32.99,
        name: "CIM Motor",
    },
    "217-4018": {
        cost: 4.99,
        name: "CIM Adapter",
    },
    "217-6417": {
        cost: 39.99,
        name: "Versa DM Aluminum"
    }
}


export const OUTPUT  = Symbol("OUTPUT")
export const INPUT = Symbol("INPUT")
export const STAGE = Symbol("STAGE")
export const SPECIAL = Symbol("SPECIAL")

export const SLICES = [
    {
        name: "3:1 Stage",
        reduction: 3,
        maxTorque: Infinity,
        parts: ["217-2817", "217-2816"],
        type: STAGE
    },
    {
        name: "4:1 Stage",
        reduction: 4,
        maxTorque: Infinity,
        parts: ["217-2818", "217-2816"],
        type: STAGE
    },
    {
        name: "5:1 Stage",
        reduction: 5,
        maxTorque: Infinity,
        parts: ["217-2819", "217-2816"],
        type: STAGE
    },
    {
        name: "7:1 Stage",
        reduction: 7,
        maxTorque: null,
        parts: ["217-3102", "217-2816"],
        type: STAGE
    },
    {
        name: "9:1 Stage",
        reduction: 9,
        maxTorque: null,
        parts: ["217-3106", "217-2816"],
        type: STAGE
    },
    {
        name: "10:1 Stage",
        reduction: 10,
        maxTorque: null,
        parts: ["217-2820", "217-2816"],
        type: STAGE
    },
    {
        name: "CIM Motor Input",
        reduction: 1,
        maxTorque: null,
        inputTorque: 2.41,
        parts: ["217-2000", "217-4018"],
        type: INPUT
    },
    {
        name: "Mini CIM Motor Input",
        reduction: 1,
        maxTorque: null,
        inputTorque: 1.41,
        parts: ["217-3371", "217-4018"],
        type: INPUT
    },
    {
        name: "Bag Motor Input",
        reduction: 1,
        maxTorque: null,
        inputTorque: .43,
        parts: ["217-3351"],
        type: INPUT
    },
    {
        name: "775 Pro Input",
        reduction: 1,
        maxTorque: null,
        inputTorque: .74,
        parts: ["217-4347"],
        type: INPUT
    },
    {
        name: "VersaDM Bag Input",
        reduction: 1,
        maxTorque: null,
        inputTorque: .86,
        parts: ["217-3351", "217-3351", "217-6417"],
        type: INPUT
    },
    {
        name: "VersaDM 775 Pro Input",
        reduction: 1,
        maxTorque: null,
        inputTorque: 1.48,
        parts: ["217-4347", "217-4347", "217-6417"],
        type: INPUT
    },
    {
        name: "1/2 Hex Output",
        reduction: 1,
        maxTorque: 157,
        parts: ["217-4973"],
        type: OUTPUT
    },
    {
        name: "1/2 Round Output",
        maxTorque: 130,
        reduction: 1,
        type: OUTPUT,
        parts: ["217-4975"]
    },
    {
        name: "3/8 Hex Output",
        maxTorque: 57,
        reduction: 1,
        type: OUTPUT,
        parts: ["217-4974"]
    },
    {
        name: "CIM Output",
        maxTorque: 27,
        reduction: 1,
        type: OUTPUT,
        parts: ["217-4976"]
    },
    {
        name: "Universal Female Output",
        maxTorque: 27,
        reduction: 1,
        type: OUTPUT,
        parts: ["217-6473"]
    }

]

export const OUTPUTS = [
    {
        name: "1/2 Hex",
        maxTorque: 157,
        partNo: ["217-4973"],
        cost: [39.99]
    },
    {
        name: "1/2 Round",
        maxTorque: 130,
        partNo: ["217-4975"],
        cost: [39.99]
    },
    {
        name: "3/8 Hex",
        maxTorque: 57,
        partNo: ["217-4974"],
        cost: [39.99]
    },
    {
        name: "CIM Output",
        maxTorque: 27,
        partNo: ["217-4976"],
        cost: [39.99]
    },
    {
        name: "Universal Female Output",
        maxTorque: 27,
        partNo: ["217-6473"],
        cost: [44.99]
    }
]

export const INPUTS = [
    {
        name: "775Pro",
        torque: .71,
        partNo: ["217-4347"],
        cost: [19.99]
    }
]

export const STAGES = [
    {
        name: "3:1",
        reduction: 3,
        maxTorque: null,
        partNo: ["217-2817", "217-2816"],
        cost: [14.99, 9.99]
    },
    {
        name: "4:1",
        reduction: 4,
        maxTorque: null,
        partNo: ["217-2818", "217-2816"],
        cost: [14.99, 9.99]
    },
    {
        name: "5:1",
        reduction: 5,
        maxTorque: null,
        partNo: ["217-2819", "217-2816"],
        cost: [14.99, 9.99]
    },
    {
        name: "7:1",
        reduction: 7,
        maxTorque: null,
        partNo: ["217-3102", "217-2816"],
        cost: [14.99, 9.99]
    },
    {
        name: "9:1",
        reduction: 9,
        maxTorque: null,
        partNo: ["217-3106", "217-2816"],
        cost: [14.99, 9.99]
    },

    {
        name: "10:1",
        reduction: 10,
        maxTorque: null,
        partNo: ["217-2820", "217-2816"],
        cost: [14.99, 9.99]
    }
]
